import { render, staticRenderFns } from "./HouseholdIncomeTile.vue?vue&type=template&id=01468b12"
import script from "./HouseholdIncomeTile.vue?vue&type=script&lang=js"
export * from "./HouseholdIncomeTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../config/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports